import type { HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/components/ui/cn";

const vBadgeVariants = cva(
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-medium",
  {
    variants: {
      color: {
        primary: "bg-primary-50 text-primary-700 ring-primary-600/20",
        secondary: "bg-secondary-50 text-secondary-700 ring-secondary-600/20",
        success: "bg-success-50 text-success-700 ring-success-600/20",
        warning: "bg-warning-50 text-warning-800 ring-warning-600/25",
        error: "bg-error-50 text-error-700 ring-error-600/20",
        info: "bg-info-50 text-info-700 ring-info-600/20",
        neutral: "bg-neutral-100 text-neutral-600 ring-neutral-500/20",
      },
      // "count": compacte teller naast een titel of tab, zonder ring.
      size: {
        md: "px-2.5 py-1 text-xs ring-1 ring-inset",
        count: "px-1.5 py-0 text-[11px] leading-5",
      },
    },
    defaultVariants: {
      color: "neutral",
      size: "md",
    },
  },
);

type VBadgeProps = HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof vBadgeVariants>;

export function VBadge({ className, color, size, ...props }: VBadgeProps): React.JSX.Element {
  return <span className={cn(vBadgeVariants({ color, size }), className)} {...props} />;
}

export type { VBadgeProps };
